<template>
    <div>   
      <div class="page-header">
          <h3>{{ $t('components') }}</h3>
          <button :disabled="!components.length == 0 || !children.length == 0" v-if="canEdit" @click="deleteCategory()"  class="btn ml-auto btn-danger mr-4">
              <fa :icon="['fal','times']" /> {{ $t('Radera kategori') }}
          </button>
          <router-link v-if="canEdit" :to="{path : '/admin/categories/' + query.category_id + '/edit'}" class="btn btn-primary mr-4">
              <fa :icon="['fal','edit']" /> {{ $t('edit_category') }}
          </router-link>

          <router-link v-if="canEdit" :to="{name : 'components.create'}" class="btn btn-success">
              <fa :icon="['fal','plus-circle']" /> {{ $t('add_new_component') }}
          </router-link>
      </div>
    
      <grid 
        :data="components"
        :columns="columns"
        v-on:update-data="fetchData"
        v-on:row-clicked="rowClick"
        edit-route="/components"
        delete-route="/api/component"
        with-edit
        with-delete></grid>

      <component-modal :component-id="activeComponent" v-on:clear="resetRoute" />
    </div>
</template>

<script>
import axios from 'axios';
import store from '~/store'
import Grid from "~/components/Grid";
import ComponentModal from "~/components/ComponentModal";

export default {
  middleware: ['auth'],
  metaInfo () {
    return { title: this.$t('components') }
  },
  components : {
    Grid, ComponentModal
  },
  data(){
    return {
      activeComponent: null,
      components : [],
      categories : [],
      children: [],
      columns : [
        { 'col' : 'attachment.filename','title' : 'Namn', 'width':'25%'},
        { 'col' : 'attachment.attachment_pages_count','title' : 'Sidor'},
        { 'col' : 'printables_count','title' : 'Artiklar'},
        { 'col' : 'created_at', 'title' :'Skapades'},
        { 'col' : 'updated_at', 'title' :'Senast ändrad'},
      ]}
  },
  created(){
    if(this.query.category_id){
      this.fetchData();
      this.activeComponent = this.params.id;
    } 
    this.fetchCategories();
  },
  watch: {
    '$route': 'routeChanged',

    query: function (val) {
        this.checkForChildCategories();
    }
  },
  computed: {
    component_type(){
      return this.$route.query.component_type ? this.$route.query.component_type : false;
    },
    query(){
      return this.$route.query ? this.$route.query : false;
    },
    category() {
        return this.categories.filter(cat => cat.value == this.query.category_id);
    },
    params(){
      return this.$route.params;
    },
    canEdit(){
      return store.getters['auth/user'].role >= 3
    },
    currentCompany(){
      var company = store.getters['auth/company'];
      return company
    }
  },
  methods: {
    reRoute(){
      this.$router.push({
        path : '/components?company_id=' + this.currentCompany.id, 
        query: this.query
      })
    },
    resetRoute(){
      this.activeComponent = null;

      this.$router.push({
        path : '/components', 
        query: this.query
      })
    },
    routeChanged(newRoute,oldRoute){
      if(newRoute.query !== oldRoute.query){
        this.fetchData();
      }

      if(newRoute.params.id !== oldRoute.params.id){
        this.activeComponent = newRoute.params.id;
      }
    },
    rowClick(entry){
      this.$router.push({
        path : '/components/' + entry.id, 
        query: this.query
      })
        
      this.checkForChildCategories();
    },
    checkForChildCategories() {
        this.children = this.categories.filter(cat => cat.parent_id == this.query.category_id);
    },
    async fetchCategories() {
        let url = '/api/category/getAll';
        const { data } = await axios.get(url);

        this.categories = data;

        this.checkForChildCategories();
    },
    async deleteCategory() {

        if(confirm('Är du säker på att du vill radera kategorin?')) {
            let url = '/api/category/' + this.query.category_id;
        
            const { data } = await axios.delete(url);
            console.log(data);
            location.reload();
        };
    },
    async fetchData(){
      var q = this.query;
      
      let url = '/api/component?' + Object.keys(q).map(function(k) {
          if(q[k]){
            return encodeURIComponent(k) + '=' + encodeURIComponent(q[k])
          }
      }).join('&');
      
      const { data } = await axios.get(url);
      this.components = data;
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/components/index.vue